<template>
  <div>
    <div class="text-sm text-text -mt-2">{{ $t('notPlanned', {month: currentMonth}) }}</div>
    <BaseButton v-if="!currentUserIsWatcher" @click="$router.push({name:'budget'})"
                theme="red"
                class="w-full mt-17-5">{{ $t('createNow') }}
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import {mapGetters} from "vuex";

export default {
  name: "MyBudgetsEmpty",
  components: {BaseButton},
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
    currentMonth() {
      return this.$moment().locale(this.$i18n.locale).format('MMMM').toLowerCase()
    }
  },
  i18n: {
    messages: {
      en: {
        notPlanned: 'Budget on {month} is not created.',
        createNow: 'Create now'
      },
      ru: {
        notPlanned: 'Бюджет на {month} не спланирован.',
        createNow: 'Создать сейчас'
      },
    }
  }
}
</script>

<style scoped>

</style>